import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useRef, useState } from "react";
import * as Yup from "yup";
import { Formik, Form, Field, FieldArray } from "formik";
import { Grid, Dialog, Button, SubmitButton, DatePicker, TimePicker, HorizontalStepperTemplate, CreatableSelectSM, SearchSelect } from "../../../../../../";
import { makeStyles } from "@material-ui/styles";
import { TextField } from "formik-material-ui";
import { Debug } from "../../../../../../Molecules/Forms/Debug";
import { Divider, Typography } from "@material-ui/core";
var staffDefaultSchema = Yup.object().shape({
  groupId: Yup.string().required()
});
var staffSelectSchema = Yup.object().shape({
  groupId: Yup.string().required(),
  staffId: Yup.string().required()
});
var staffCreateSchema = Yup.object().shape({
  groupId: Yup.string().required(),
  name: Yup.string().required(),
  email: Yup.string().email().required(),
  phone: Yup.string().required(),
  identificationNumber: Yup.string(),
  ssn: Yup.string(),
  bankAccountNumber: Yup.string(),
  sports: Yup.array()
});
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      display: "flex",
      "flex-wrap": "wrap"
    },
    form: {
      display: "flex"
    },
    repeat: {
      margin: 0
    },
    mr30: {
      marginRight: "30px"
    },
    actions: {
      display: "flex",
      justifyContent: "flex-end"
    },
    flex: {
      display: "flex"
    },
    divider: {
      margin: "4px 0"
    },
    actionsParent: {
      display: "flex",
      alignItems: "center"
    }
  };
});

var DialogCampusGroupSingleAddStaffTrainer = function DialogCampusGroupSingleAddStaffTrainer(props) {
  var _useState = useState("default"),
      _useState2 = _slicedToArray(_useState, 2),
      optionFlow = _useState2[0],
      setOptionFlow = _useState2[1];

  var initialValues = {
    groupId: props.groupId,
    name: "",
    email: "",
    phone: "",
    identificationNumber: "",
    ssn: "",
    bankAccountNumber: "",
    sports: [],
    staffId: "",
    role: "trainer"
  };
  var stepperRef = useRef();

  var selectSchema = function selectSchema() {
    switch (optionFlow) {
      case "default":
        return staffDefaultSchema;

      case "create":
        return staffCreateSchema;

      case "select":
        return staffSelectSchema;

      default:
        return null;
    }
  };

  var handleSelectOption = function handleSelectOption(option) {
    switch (option) {
      case "select":
        props.handleDownloadSMStaff().then(function (x) {
          setOptionFlow(option);
          handleNextStepper();
        });
        break;

      case "create":
        setOptionFlow(option);
        handleNextStepper();
        break;

      default:
        break;
    }
  };

  var handleBackOption = function handleBackOption() {
    setOptionFlow("default");
    handlePreviousStepper();
  };

  var handlePreviousStepper = function handlePreviousStepper() {
    stepperRef.current.handleActionStepper("previous_step");
  };

  var handleNextStepper = function handleNextStepper() {
    stepperRef.current.handleActionStepper("next_step");
  };

  var handleClose = function handleClose() {
    stepperRef.current.handleActionStepper("reset");
    props.onClose();
  };

  var createLabelSteps = function createLabelSteps() {
    var labels;

    switch (optionFlow) {
      case "select":
        labels = props.translation && props.translation.steps && props.translation.steps[optionFlow] || ["Step 1", "Step 2"];
        break;

      case "create":
        labels = props.translation && props.translation.steps && props.translation.steps[optionFlow] || ["Step 1", "Step 2", "Step 3"];
        break;

      case "default":
        labels = props.translation && props.translation.steps && props.translation.steps[optionFlow] || ["Step 1"];
        break;

      default:
        labels = [];
        break;
    }

    return labels;
  };

  var createContentSteps = function createContentSteps(values) {
    switch (optionFlow) {
      case "default":
        return [/*#__PURE__*/React.createElement(Grid, {
          container: true,
          spacing: 2
        }, /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 6
        }, /*#__PURE__*/React.createElement(Button, {
          variant: "contained",
          color: "primary",
          fullWidth: true,
          onClick: function onClick() {
            return handleSelectOption("select");
          }
        }, props.translation ? props.translation.buttons ? props.translation.buttons.select_staff || "Select Staff" : "Select Staff" : "Select Staff")), /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 6
        }, /*#__PURE__*/React.createElement(Button, {
          variant: "contained",
          color: "primary",
          fullWidth: true,
          onClick: function onClick() {
            return handleSelectOption("create");
          }
        }, props.translation ? props.translation.buttons ? props.translation.buttons.create_staff || "Create Staff" : "Create Staff" : "Create Staff")))];

      case "create":
        return [/*#__PURE__*/React.createElement(Grid, {
          container: true,
          spacing: 2
        }, /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 6
        }, /*#__PURE__*/React.createElement(Button, {
          variant: "contained",
          color: "primary",
          fullWidth: true,
          onClick: function onClick() {
            return handleSelectOption("select");
          }
        }, props.translation ? props.translation.buttons ? props.translation.buttons.select_staff || "Select Staff" : "Select Staff" : "Select Staff")), /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 6
        }, /*#__PURE__*/React.createElement(Button, {
          variant: "contained",
          color: "primary",
          fullWidth: true,
          onClick: function onClick() {
            return handleSelectOption("create");
          }
        }, props.translation ? props.translation.buttons ? props.translation.buttons.create_staff || "Create Staff" : "Create Staff" : "Create Staff"))), /*#__PURE__*/React.createElement(Grid, {
          container: true,
          spacing: 2
        }, /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 12
        }, /*#__PURE__*/React.createElement(Field, {
          component: TextField,
          label: props.translation ? props.translation.inputs ? props.translation.inputs.name || "Name" : "Name" : "Name",
          name: "name",
          variant: "outlined",
          fullWidth: true,
          margin: "normal"
        })), /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 6
        }, /*#__PURE__*/React.createElement(Field, {
          component: TextField,
          label: props.translation ? props.translation.inputs ? props.translation.inputs.email || "Email" : "Email" : "Email",
          name: "email",
          variant: "outlined",
          fullWidth: true,
          margin: "normal"
        })), /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 6
        }, /*#__PURE__*/React.createElement(Field, {
          component: TextField,
          label: props.translation ? props.translation.inputs ? props.translation.inputs.phone || "Telephone" : "Telephone" : "Telephone",
          name: "phone",
          variant: "outlined",
          fullWidth: true,
          margin: "normal"
        })), /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 12
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "body1"
        }, props.translation ? props.translation.texts ? props.translation.texts.optional || "Optional" : "Optional" : "Optional")), /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 6
        }, /*#__PURE__*/React.createElement(Field, {
          component: TextField,
          label: props.translation ? props.translation.inputs ? props.translation.inputs.identification_number || "Identification Number" : "Identification Number" : "Identification Number",
          name: "identificationNumber",
          variant: "outlined",
          fullWidth: true,
          margin: "normal"
        })), /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 6
        }, /*#__PURE__*/React.createElement(Field, {
          component: TextField,
          label: props.translation ? props.translation.inputs ? props.translation.inputs.ssn || "Social Number" : "Social Number" : "Social Number",
          name: "ssn",
          variant: "outlined",
          fullWidth: true,
          margin: "normal"
        })), /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 12
        }, /*#__PURE__*/React.createElement(Field, {
          component: TextField,
          label: props.translation ? props.translation.inputs ? props.translation.inputs.bank_account_number || "Bank Account Number" : "Bank Account Number" : "Bank Account Number",
          name: "bankAccountNumber",
          variant: "outlined",
          fullWidth: true,
          margin: "normal"
        }))), /*#__PURE__*/React.createElement(Grid, {
          container: true,
          spacing: 2
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "body1"
        }, props.translation ? props.translation.texts ? props.translation.texts.sports || "These are the sports that this coach / coordinator can teach" : "These are the sports that this coach / coordinator can teach" : "These are the sports that this coach / coordinator can teach"), /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 12
        }, /*#__PURE__*/React.createElement(Field, {
          name: "sports",
          key: "sports",
          component: CreatableSelectSM,
          label: props.translation ? props.translation.selects ? props.translation.selects.sports || "Sports" : "Sports" : "Sports",
          options: values.sports ? values.sports.map(function (sport) {
            return {
              label: sport,
              value: sport
            };
          }) : [],
          variant: "outlined",
          isMulti: true
        })))];

      case "select":
        return [/*#__PURE__*/React.createElement(Grid, {
          container: true,
          spacing: 2
        }, /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 6
        }, /*#__PURE__*/React.createElement(Button, {
          variant: "contained",
          color: "primary",
          fullWidth: true,
          onClick: function onClick() {
            return handleSelectOption("select");
          }
        }, props.translation ? props.translation.buttons ? props.translation.buttons.select_staff || "Select Staff" : "Select Staff" : "Select Staff")), /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 6
        }, /*#__PURE__*/React.createElement(Button, {
          variant: "contained",
          color: "primary",
          fullWidth: true,
          onClick: function onClick() {
            return handleSelectOption("create");
          }
        }, props.translation ? props.translation.buttons ? props.translation.buttons.create_staff || "Create Staff" : "Create Staff" : "Create Staff"))), /*#__PURE__*/React.createElement(Grid, {
          container: true,
          spacing: 2
        }, props.sm_staff.map(function (staffWorker) {
          return {
            label: staffWorker.name,
            value: staffWorker._id
          };
        }).filter(function (staffWorker) {
          return (// si existe en staff del campus
            props.campus_staff.some(function (_staffWorker) {
              return _staffWorker._id === staffWorker.value;
            }) ? // si es distinto de coordinator
            props.campus_staff.some(function (_staffWorker) {
              return _staffWorker.role !== "coordinator" && _staffWorker._id === staffWorker.value;
            }) ? // si no se encuentra en ese grupo
            props.campus_staff.some(function (_staffWorker) {
              return _staffWorker._id === staffWorker.value && !_staffWorker.groups.includes(values.groupId);
            }) : false : true
          );
        }).length === 0 ? /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 12
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "body1",
          align: "center"
        }, props.translation ? props.translation.texts ? props.translation.texts.empty_options || "Empty options" : "Empty options" : "Empty options")) : /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 12
        }, /*#__PURE__*/React.createElement(Field, {
          name: "staffId",
          key: "staffId",
          component: SearchSelect,
          label: props.translation ? props.translation.selects ? props.translation.selects.staff || "Staff" : "Staff" : "Staff",
          options: props.sm_staff.map(function (staffWorker) {
            return {
              label: staffWorker.name,
              value: staffWorker._id
            };
          }).filter(function (staffWorker) {
            return (// si existe en staff del campus
              props.campus_staff.some(function (_staffWorker) {
                return _staffWorker._id === staffWorker.value;
              }) ? // si es distinto de coordinator
              props.campus_staff.some(function (_staffWorker) {
                return _staffWorker.role !== "coordinator" && _staffWorker._id === staffWorker.value;
              }) ? // si no se encuentra en ese grupo
              props.campus_staff.some(function (_staffWorker) {
                return _staffWorker._id === staffWorker.value && !_staffWorker.groups.includes(values.groupId);
              }) : false : true
            );
          }),
          variant: "outlined"
        })))];

      default:
        break;
    }
  };

  var createActionSteps = function createActionSteps(values, isValid, isSubmitting, errors) {
    switch (optionFlow) {
      case "default":
        return [/*#__PURE__*/React.createElement(Grid, {
          container: true,
          className: classes.actions
        }, /*#__PURE__*/React.createElement(Button, {
          type: "button",
          size: "medium",
          className: classes.mr30,
          color: "secondary",
          variant: "outlined",
          onClick: props.onClose
        }, props.translation ? props.translation.buttons ? props.translation.buttons.cancel || "Cancel" : "Cancel" : "Cancel"))];

      case "select":
        return [/*#__PURE__*/React.createElement(Grid, {
          container: true,
          className: classes.actions
        }, /*#__PURE__*/React.createElement(Button, {
          type: "button",
          size: "medium",
          className: classes.mr30,
          color: "secondary",
          variant: "outlined",
          onClick: props.onClose
        }, props.translation ? props.translation.buttons ? props.translation.buttons.cancel || "Cancel" : "Cancel" : "Cancel")), /*#__PURE__*/React.createElement(Grid, {
          container: true,
          className: classes.actions
        }, /*#__PURE__*/React.createElement(Button, {
          type: "button",
          size: "medium",
          className: classes.mr30,
          color: "secondary",
          variant: "outlined",
          onClick: handlePreviousStepper
        }, props.translation ? props.translation.buttons ? props.translation.buttons.back || "Back" : "Back" : "Back"), props.sm_staff.map(function (staffWorker) {
          return {
            label: staffWorker.name,
            value: staffWorker._id
          };
        }).filter(function (staffWorker) {
          return (// si existe en staff del campus
            props.campus_staff.some(function (_staffWorker) {
              return _staffWorker._id === staffWorker.value;
            }) ? // si es distinto de coordinator
            props.campus_staff.some(function (_staffWorker) {
              return _staffWorker.role !== "coordinator" && _staffWorker._id === staffWorker.value;
            }) ? // si no se encuentra en ese grupo
            props.campus_staff.some(function (_staffWorker) {
              return _staffWorker._id === staffWorker.value && !_staffWorker.groups.includes(values.groupId);
            }) : false : true
          );
        }).length === 0 ? /*#__PURE__*/React.createElement(Button, {
          variant: "contained",
          color: "primary",
          onClick: function onClick() {
            setOptionFlow("create");
          }
        }, props.translation ? props.translation.buttons ? props.translation.buttons.empty_options || "Change to create" : "Change to create" : "Change to create") : /*#__PURE__*/React.createElement(Button, {
          size: "medium",
          color: "primary",
          variant: "outlined",
          disabled: !isValid || isSubmitting || values.staffId === "" || errors.staffId,
          component: SubmitButton,
          type: "submit"
        }, props.translation ? props.translation.buttons ? props.translation.buttons.submit || "Save" : "Save" : "Save"))];

      case "create":
        return [/*#__PURE__*/React.createElement(Grid, {
          container: true,
          className: classes.actions
        }, /*#__PURE__*/React.createElement(Button, {
          type: "button",
          size: "medium",
          className: classes.mr30,
          color: "secondary",
          variant: "outlined",
          onClick: props.onClose
        }, props.translation ? props.translation.buttons ? props.translation.buttons.cancel || "Cancel" : "Cancel" : "Cancel")), /*#__PURE__*/React.createElement(Grid, {
          container: true,
          className: classes.actions
        }, /*#__PURE__*/React.createElement(Button, {
          type: "button",
          size: "medium",
          className: classes.mr30,
          color: "secondary",
          variant: "outlined",
          onClick: handlePreviousStepper
        }, props.translation ? props.translation.buttons ? props.translation.buttons.back || "Back" : "Back" : "Back"), /*#__PURE__*/React.createElement(Button, {
          size: "medium",
          color: "primary",
          variant: "outlined",
          disabled: values.name === "" || values.email === "" || values.phone === "" || errors.name || errors.email || errors.phone,
          onClick: handleNextStepper
        }, props.translation ? props.translation.buttons ? props.translation.buttons.next || "Next" : "Next" : "Next")), /*#__PURE__*/React.createElement(Grid, {
          container: true,
          className: classes.actions
        }, /*#__PURE__*/React.createElement(Button, {
          type: "button",
          size: "medium",
          className: classes.mr30,
          color: "secondary",
          variant: "outlined",
          onClick: handlePreviousStepper
        }, props.translation ? props.translation.buttons ? props.translation.buttons.back || "Back" : "Back" : "Back"), /*#__PURE__*/React.createElement(Button, {
          size: "medium",
          color: "primary",
          variant: "outlined",
          disabled: !isValid || isSubmitting,
          component: SubmitButton,
          type: "submit"
        }, props.translation ? props.translation.buttons ? props.translation.buttons.submit || "Save" : "Save" : "Save"))];

      default:
        break;
    }
  };

  var classes = useStyles();
  return /*#__PURE__*/React.createElement(Dialog, {
    fullWidth: true,
    maxWidth: "lg",
    title: props.translation ? props.translation.title || "Add staff" : "Add staff",
    open: props.open,
    onClose: handleClose
  }, /*#__PURE__*/React.createElement(Formik, {
    initialValues: initialValues,
    validationSchema: selectSchema(),
    onSubmit: function onSubmit(values) {
      props.onSubmit(_objectSpread(_objectSpread({}, values), {}, {
        option: optionFlow,
        sports: {
          canTeach: values.sports
        }
      }));
      props.onClose();
    },
    render: function render(_ref) {
      var values = _ref.values,
          isValid = _ref.isValid,
          isSubmitting = _ref.isSubmitting,
          errors = _ref.errors;
      return /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(HorizontalStepperTemplate, {
        ref: stepperRef,
        steps: createLabelSteps(),
        contentSteps: createContentSteps(values),
        actionsSteps: createActionSteps(values, isValid, isSubmitting, errors)
      }));
    }
  }));
};

export { DialogCampusGroupSingleAddStaffTrainer };